import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-it-agility',
  templateUrl: './it-agility.component.html',
  styleUrls: ['./it-agility.component.sass']
})
export class ItAgilityComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    document.querySelector(".__page-root").scrollIntoView(true);
  }

}
